import React from "react"
import _ from "lodash"
import { View } from "react-native"
import { Badge, Body, Icon, Right, ListItem, Text } from "native-base"
import ProfileImage from "components/views/Shared/ProfileImage"
import styles from "./styles"
import { Offer } from "modules/Buyer/Offers/types"
import { BuyerProfile } from "modules/BuyerProfiles/types"
import { Category } from "modules/Buyer/Categories/types"
import { getLocaLizedName } from "utilities/Redux/normalizeHelpers"
import { getOfferStartDateString } from "utilities/time"

interface Props {
  offer?: Offer
  buyerProfile?: BuyerProfile
  category?: Category
  unseenMessages: number
  onPress: () => void
  last: boolean
}

export default ({
  offer,
  buyerProfile,
  category,
  unseenMessages,
  onPress,
  last,
}: Props) => {
  if (!buyerProfile || !category || !offer) {
    return null
  }
  const agreedDate = getOfferStartDateString(offer)
  const photoUrl = buyerProfile.photoURL
  const { seenBySeller } = offer

  return (
    <ListItem onPress={onPress} style={last ? styles.lastItem : null}>
      <ProfileImage style={styles.thumbnail} small source={photoUrl} />
      <Body style={styles.textWrap}>
        <Text
          style={[styles.title, !seenBySeller ? styles.titleHighlighted : null]}
        >
          {buyerProfile.displayName}
        </Text>
        <View style={styles.info}>
          <Text style={styles.infoText}>{getLocaLizedName(category.name)}</Text>
          <Text style={styles.infoSeparator}>•</Text>
          <Text style={styles.infoText}>{agreedDate}</Text>
        </View>
      </Body>
      <Right>
        <View style={styles.rightWrap}>
          {unseenMessages ? (
            <Badge style={styles.notification}>
              <Text style={styles.notificationText}>{unseenMessages}</Text>
            </Badge>
          ) : null}
          <Icon name="arrow-forward" style={styles.icon} />
        </View>
      </Right>
    </ListItem>
  )
}
